import '../../assets/colors.scss';
import '../../assets/variables.scss';

export function GlobalScss() {
  return <></>;
}
